import React from 'react';
import UpdateDanger from './updateDanger/updateDanger'
import UpdateDark from './updateDark/updateDark'
import UpdateWarning from './updateWarning/updateWarning'

export const columns = [
  {
    name: 'id',
    label: '',
    options: {
      filter: false,
      sort: false,
      display: 'excluded',
    },
  },

  //
  // 🔹 NOVA COLUNA — bloco contendo nome, e-mail e tipo do usuário
  //
  {
    name: 'user',
    label: 'Usuário',
    options: {
      setCellHeaderProps: () => ({
        style: { textAlign: 'center' },
      }),
      setCellProps: () => ({
        style: { textAlign: 'center' },
      }),
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        if (!value) return '--';

        return (
          <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
            <strong>{value.name}</strong>
            <span style={{ fontSize: '12px', color: '#555' }}>{value.email}</span>
          </div>
        );
      }
    }
  },
  {
    name: 'user',
    label: 'Tipo de Usuário',
    options: {
      setCellHeaderProps: () => ({
        style: { textAlign: 'center' },
      }),
      setCellProps: () => ({
        style: { textAlign: 'center' },
      }),
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        if (!value) return '--';

        return (
          <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
            <strong>{value.type_label ?? "-"}</strong>
            <span style={{ fontSize: '12px', color: '#555' }}>{value.customer_name ?? "-"}</span>
          </div>
        );
      }
    }
  },
  {
    name: 'id_user',
    label: '',
    options: {
      filter: false,
      sort: false,
      display: 'excluded',
    },
  },

  {
    name: 'warning',
    label: 'Alerta Médio',
    options: {
      print: false,
      setCellHeaderProps: () => ({
        style: { textAlign: 'center', width: '30%' },
      }),
      setCellProps: () => ({
        style: { textAlign: 'center' },
      }),
      filter: true,
      sort: false,
      customBodyRender: (value, tableMeta) => (
        <UpdateWarning
          id={tableMeta.rowData[0]}
          activeDefault={value}
          idUser={tableMeta.rowData[4]}
          page={tableMeta.tableState.page}
          rowsPage={tableMeta.tableState.rowsPerPage}
          search={!tableMeta.tableState.search ? '' : tableMeta.tableState.search}
        />
      ),
    },
  },

  {
    name: 'danger',
    label: 'Alerta Urgente',
    options: {
      print: false,
      setCellHeaderProps: () => ({
        style: { textAlign: 'center', width: '30%' },
      }),
      setCellProps: () => ({
        style: { textAlign: 'center' },
      }),
      filter: true,
      sort: false,
      customBodyRender: (value, tableMeta) => (
        <UpdateDanger
          id={tableMeta.rowData[0]}
          activeDefault={value}
          idUser={tableMeta.rowData[4]}
          page={tableMeta.tableState.page}
          rowsPage={tableMeta.tableState.rowsPerPage}
          search={!tableMeta.tableState.search ? '' : tableMeta.tableState.search}
        />
      ),
    },
  },

  {
    name: 'dark',
    label: 'Alerta Crítico',
    options: {
      print: false,
      setCellHeaderProps: () => ({
        style: { textAlign: 'center', width: '30%' },
      }),
      setCellProps: () => ({
        style: { textAlign: 'center' },
      }),
      filter: true,
      sort: false,
      customBodyRender: (value, tableMeta) => (
        <UpdateDark
          id={tableMeta.rowData[0]}
          activeDefault={value}
          idUser={tableMeta.rowData[4]}
          page={tableMeta.tableState.page}
          rowsPage={tableMeta.tableState.rowsPerPage}
          search={!tableMeta.tableState.search ? '' : tableMeta.tableState.search}
        />
      ),
    },
  },
];
